import * as React from "react";
function SvgArrowRight(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.707 19.714l7-7a1 1 0 000-1.414l-7-7-1.414 1.414 5.293 5.293H3v2h14.586L12.293 18.3l1.414 1.414z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgArrowRight);
export default ForwardRef;
